var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandbag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 6C7.25 3.37665 9.37665 1.25 12 1.25C14.6234 1.25 16.75 3.37665 16.75 6H20.6667C21.403 6 22 6.59695 22 7.33333C22 10.6179 19.6246 13.3477 16.498 13.8986C16.4448 12.5649 15.3468 11.5 14 11.5H10C8.65325 11.5 7.55522 12.5649 7.50202 13.8986C4.37539 13.3477 2 10.6179 2 7.33333C2 6.59695 2.59695 6 3.33333 6H7.25ZM8.75 6H15.25C15.25 4.20507 13.7949 2.75 12 2.75C10.2051 2.75 8.75 4.20507 8.75 6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53555 15.4223C7.73623 16.6019 8.76325 17.5 10 17.5H14C15.2368 17.5 16.2638 16.6019 16.4645 15.4223C18.3631 15.1592 20.0532 14.2434 21.3007 12.9088L21.8344 19.8466C21.9237 21.0082 21.0053 22 19.8402 22H4.15978C2.99476 22 2.07632 21.0082 2.16568 19.8466L2.69935 12.9088C3.94687 14.2434 5.6369 15.1592 7.53555 15.4223Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14C9 13.4477 9.44772 13 10 13H14C14.5523 13 15 13.4477 15 14V15C15 15.5523 14.5523 16 14 16H10C9.44772 16 9 15.5523 9 15V14Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandbag);
export default __webpack_public_path__ + "static/media/handbag.0905fe2d3021e2cf330879a5b85dd13a.svg";
export { ForwardRef as ReactComponent };